export default __webpack_public_path__ + "static/media/rewind_10.d2d99c0f.svg";